import { lazy } from "react"
import AnimalView from "../views/animal-view/animal-view"
import {
  ANIMAL_PROFILE_VIEW,
  ANIMAL_VIEW,
  FARM_VIEW,
  NEW_ANIMAL_VIEW,
} from "./route-list"
import { FarmTab } from "@/features/farm"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

const AnimalProfile = lazy(
  () => import("@/features/farm/views/animal-profile/animal-profile.tsx"),
)
const NewAnimalView = lazy(
  () => import("@/features/farm/views/new-animal-view/new-animal-view.tsx"),
)
const BottomMenuLayout = lazy(
  () => import("@/layouts/bottom-menu-layout/bottom-menu-layout.tsx"),
)

export const noMenuLayoutFarmRoutes = [
  {
    path: NEW_ANIMAL_VIEW,
    element: <NewAnimalView />,
  },
  {
    path: `${ANIMAL_VIEW}/:animalId`,
    element: <AnimalView />,
  },
  {
    path: `${ANIMAL_PROFILE_VIEW}/:animalId`,
    element: <AnimalProfile />,
  },
]

export const bottomMenuLayoutFarmRoutes = [
  {
    path: FARM_VIEW,
    element: <FarmTab />,
  },
]

export const MOBILE_NO_MENU_LAYOUT_FARM_ROUTES = {
  element: <NoMenuLayout />,
  children: noMenuLayoutFarmRoutes,
}

export const MOBILE_BOTTOM_MENU_LAYOUT_FARM_ROUTES = {
  element: <BottomMenuLayout />,
  children: bottomMenuLayoutFarmRoutes,
}

export const MOBILE_FARM_ROUTES = [
  MOBILE_NO_MENU_LAYOUT_FARM_ROUTES,
  MOBILE_BOTTOM_MENU_LAYOUT_FARM_ROUTES,
]

export const DESKTOP_FARM_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: [...bottomMenuLayoutFarmRoutes, ...noMenuLayoutFarmRoutes],
  },
]

export const getFarmRoutes = (isDesktop: boolean) => {
  return isDesktop ? DESKTOP_FARM_ROUTES : MOBILE_FARM_ROUTES
}
